"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateActionForm = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _reactFinalForm = require("react-final-form");

var _finalForm = require("final-form");

var _core = require("@lingui/core");

var _blocks = require("@bueno/blocks");

var Elements = _interopRequireWildcard(require("../CreateActionForm.styles"));

var _ActionModal = require("../../ActionModal.styles");

var lists = _interopRequireWildcard(require("../../../Action/utils/lists"));

var _validation = require("../validation");

var _Accordion = require("../../components/Accordion");

var _FieldSelectAdaptor = require("./FieldSelectAdaptor");

var _FieldTextAdaptor = require("./FieldTextAdaptor");

var _FieldAssignee = require("./FieldAssignee");

var _utils = require("../utils");

var _PristineSpy = require("./PristineSpy");

var _hooks = require("../hooks");

var _currency = require("../../../../utils/currency");

const validateFormValues = schema => async values => {
  if (typeof schema === 'function') {
    schema = schema();
  }

  try {
    await schema.validate(values, {
      abortEarly: false
    });
  } catch (err) {
    const errors = err.inner.reduce((formError, innerError) => {
      return (0, _finalForm.setIn)(formError, innerError.path, innerError.message);
    }, {});
    return errors;
  }
};

const validateFn = validateFormValues(_validation.createActionSchema);

const CreateActionForm = ({
  projectKey,
  formRef,
  onSubmit,
  setValidForm,
  setPristine,
  defaultSummary,
  defaultContext,
  site,
  sites,
  siteOptions,
  onSiteChange
}) => {
  const currencySymbol = (0, _currency.useCurrencySymbol)(projectKey);
  const disabledStatuses = (0, _hooks.useDisabledStatuses)();
  const fileInput = React.useRef(null);

  const handleInputFile = formProps => {
    if (fileInput.current === null) return;
    const {
      files
    } = fileInput.current;

    if (files !== null) {
      if (files.length <= 0) {
        // Revert to null intentionally from default state
        formProps.input.onChange(null);
      } else {
        formProps.input.onChange(files[0]);
      }
    }
  };

  return /*#__PURE__*/React.createElement(_reactFinalForm.Form, {
    initialValues: {
      summary: defaultSummary,
      screenshot: null,
      priority: 'Major',
      context: defaultContext,
      site: (0, _utils.sortByLabel)(Object.values(sites))[0].id // First site, alphabetically

    },
    onSubmit: onSubmit,
    subscription: {
      pristine: true
    },
    validate: async values => {
      const errors = await validateFn(values);
      const isValid = errors === undefined;
      setValidForm(isValid);
      return errors;
    },
    render: ({
      handleSubmit
    }) => {
      return /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit,
        ref: formRef
      }, /*#__PURE__*/React.createElement(_PristineSpy.PristineSpy, {
        onPristineChange: setPristine
      }), /*#__PURE__*/React.createElement(_ActionModal.Section, null, /*#__PURE__*/React.createElement(_ActionModal.Half, null, /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
        name: "site"
      }, ({
        input,
        meta,
        ...rest
      }) => /*#__PURE__*/React.createElement(_blocks.FieldSelect, (0, _extends2.default)({}, input, rest, {
        label: `*${_core.i18n._({
          id: 'action_form.site',
          message: 'Site'
        })}`,
        value: site !== undefined ? {
          label: site.label,
          value: site.syncoId
        } : siteOptions[0],
        options: siteOptions,
        onChange: option => {
          // * NOTE: Form requires the legacy siteId, whereas
          // * the actual value of selected site is the syncoId.
          // * This ensures the form sets the correct value
          input.onChange(sites[option.value].id);
          onSiteChange(option.value);
        },
        menuPosition: "fixed"
      })))), /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
        label: `*${_core.i18n._({
          id: 'action_form.summary_label',
          message: `Summary`
        })}`,
        name: "summary",
        component: _FieldTextAdaptor.FieldTextAdaptor
      }), /*#__PURE__*/React.createElement(Elements.ThreeColsLayout, null, /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
        label: `*${_core.i18n._({
          id: 'action_form.status_label',
          message: `Status`
        })}`,
        name: "status",
        placeholder: _core.i18n._({
          id: 'action_form.select_placeholder',
          message: `Select...`
        }),
        options: lists.getStatusOptions(_core.i18n, disabledStatuses),
        component: _FieldSelectAdaptor.FieldSelectAdaptor
      }), /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
        name: "priority"
      }, ({
        input,
        meta,
        ...rest
      }) => {
        var _meta$touched;

        return /*#__PURE__*/React.createElement(_blocks.FieldSelect, (0, _extends2.default)({}, input, rest, {
          label: `*${_core.i18n._({
            id: 'action_form.priority_label',
            message: `Severity`
          })}`,
          value: lists.getPriorityOptions(_core.i18n).find(l => l.value === input.value),
          options: lists.getPriorityOptions(_core.i18n),
          onChange: option => input.onChange(option.value),
          error: ((_meta$touched = meta.touched) !== null && _meta$touched !== void 0 ? _meta$touched : false) && Boolean(meta.error) ? meta.error : undefined,
          menuPosition: "fixed"
        }));
      }), /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
        name: "context",
        label: `*${_core.i18n._({
          id: 'action_form.context_label',
          message: `Type`
        })}`,
        options: lists.getContextOptions(_core.i18n),
        component: _FieldSelectAdaptor.FieldSelectAdaptor
      })), /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
        name: "description"
      }, props => /*#__PURE__*/React.createElement(_blocks.FieldTextarea, {
        label: `*${_core.i18n._({
          id: 'action_form.description_label',
          message: `Description`
        })}`,
        name: "description",
        value: props.input.value,
        onChange: props.input.onChange,
        placeholder: _core.i18n._({
          id: 'action_form.description_placeholder',
          message: `Detailed explanation of the problem`
        }),
        rows: 6
      }))), /*#__PURE__*/React.createElement(_Accordion.Accordion, {
        label: _core.i18n._({
          id: 'action_form.team_assignee_heading',
          message: `Team & Assignee`
        }),
        initialState: "open"
      }, /*#__PURE__*/React.createElement(Elements.TwoColsLayout, null, /*#__PURE__*/React.createElement(_reactFinalForm.FormSpy, {
        subscription: {
          values: true
        }
      }, ({
        values
      }) => {
        const siteId = values.site !== undefined ? values.site : undefined;
        return /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
          label: `*${_core.i18n._({
            id: 'action_form.team_label',
            message: `Team`
          })}`,
          name: "responsible",
          placeholder: _core.i18n._({
            id: 'action_form.select_placeholder',
            message: `Select...`
          }),
          options: lists.getResponsibleOptions(_core.i18n, siteId),
          component: _FieldSelectAdaptor.FieldSelectAdaptor,
          menuPosition: "fixed"
        });
      }), /*#__PURE__*/React.createElement(_FieldAssignee.FieldAssignee, {
        site: site !== undefined ? site.id : undefined
      }))), /*#__PURE__*/React.createElement(_Accordion.Accordion, {
        label: _core.i18n._({
          id: 'action_form.links_heading',
          message: `Links`
        }),
        persistId: "links"
      }, /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
        label: _core.i18n._({
          id: 'action_form.report_url_label',
          message: `Report URL`
        }),
        name: "skysparkLink",
        type: "text",
        component: _FieldTextAdaptor.FieldTextAdaptor
      }), /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
        name: "screenshot"
      }, props => /*#__PURE__*/React.createElement("input", {
        ref: fileInput,
        type: "file",
        onChange: () => handleInputFile(props)
      }))), /*#__PURE__*/React.createElement(_Accordion.Accordion, {
        label: _core.i18n._({
          id: 'action_form.estimated_savings_heading',
          message: `Estimated savings`
        }),
        persistId: "estimatedSavings"
      }, /*#__PURE__*/React.createElement(Elements.SubHeading, null, _core.i18n._({
        id: 'action_form.utility_savings_heading',
        message: `Utility savings`
      })), /*#__PURE__*/React.createElement(Elements.ThreeColsLayout, null, /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
        name: "elec",
        type: "number",
        label: _core.i18n._({
          id: 'action_form.electricity_label',
          message: `Electricity (kWh)`
        }),
        help: _core.i18n._({
          id: 'action_form.electricity_field_help',
          message: `Estimated annual loss`
        }),
        min: 0,
        component: _FieldTextAdaptor.FieldTextAdaptor
      }), /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
        label: _core.i18n._({
          id: 'action_form.gas_label',
          message: `Gas (GJ)`
        }),
        type: "number",
        name: "gas",
        help: _core.i18n._({
          id: 'action_form.gas_field_help',
          message: `Estimated annual loss`
        }),
        min: 0,
        component: _FieldTextAdaptor.FieldTextAdaptor
      }), /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
        label: _core.i18n._({
          id: 'action_form.water_label',
          message: `Water (kL)`
        }),
        type: "number",
        name: "water",
        help: _core.i18n._({
          id: 'action_form.water_field_help',
          message: `Estimated annual loss`
        }),
        min: 0,
        component: _FieldTextAdaptor.FieldTextAdaptor
      }), /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
        label: _core.i18n._({
          id: 'action_form.thermal_label',
          message: `Thermal (kWh)`
        }),
        type: "number",
        name: "thermal",
        help: _core.i18n._({
          id: 'action_form.thermal_field_help',
          message: `Estimated annual loss`
        }),
        min: 0,
        component: _FieldTextAdaptor.FieldTextAdaptor
      })), /*#__PURE__*/React.createElement(Elements.Divider, null), /*#__PURE__*/React.createElement(Elements.SubHeading, null, _core.i18n._({
        id: 'action_form.savings_heading',
        message: `Cost savings`
      })), /*#__PURE__*/React.createElement(Elements.ThreeColsLayout, null, /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
        label: _core.i18n._({
          id: 'action_form.energy_savings_label',
          message: `Utility savings`
        }) + ` (${currencySymbol})`,
        type: "number",
        name: "totalFinancialImpact",
        help: _core.i18n._({
          id: 'action_form.energy_savings_field_help',
          message: `Expected annual performance impact if the issue is not resolved`
        }),
        min: 0,
        component: _FieldTextAdaptor.FieldTextAdaptor
      }), /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
        label: _core.i18n._({
          id: 'action_form.operational_savings_label',
          message: `Operational savings`
        }) + ` (${currencySymbol})`,
        type: "number",
        name: "operationalSavings",
        help: _core.i18n._({
          id: 'action_form.operational_savings_field_help',
          message: `Expected annual non-utility impact if the issue is not resolved`
        }),
        min: 0,
        component: _FieldTextAdaptor.FieldTextAdaptor
      })), /*#__PURE__*/React.createElement(Elements.SubHeading, null, _core.i18n._({
        id: 'action_form.nabers_heading',
        message: `NABERS impact`
      })), /*#__PURE__*/React.createElement(Elements.ThreeColsLayout, null, /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
        label: _core.i18n._({
          id: 'action_form.nabers_energy_label',
          message: `NABERS energy (star)`
        }),
        type: "number",
        name: "nabersEnergy",
        min: 0,
        step: 0.01,
        component: _FieldTextAdaptor.FieldTextAdaptor
      }), /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
        label: _core.i18n._({
          id: 'action_form.nabers_water_label',
          message: `NABERS water (star)`
        }),
        type: "number",
        name: "nabersWater",
        min: 0,
        step: 0.01,
        component: _FieldTextAdaptor.FieldTextAdaptor
      }))), /*#__PURE__*/React.createElement(_Accordion.Accordion, {
        label: _core.i18n._({
          id: 'action_form.costs',
          message: `Costs`
        }),
        persistId: "costs"
      }, /*#__PURE__*/React.createElement(Elements.TwoColsLayout, null, /*#__PURE__*/React.createElement(_reactFinalForm.Field, {
        label: _core.i18n._({
          id: 'action_form.cost_to_complete_label',
          message: `Cost to complete`
        }) + ` (${currencySymbol})`,
        type: "number",
        name: "costToComplete",
        min: 0,
        step: 0.01,
        component: _FieldTextAdaptor.FieldTextAdaptor,
        help: _core.i18n._({
          id: 'action_form.cost_to_complete_field_help',
          message: `Total cost to rectify or implement`
        })
      }))));
    }
  });
};

exports.CreateActionForm = CreateActionForm;